import { useNavigate, useParams } from "react-router-dom";
import { taxInvoices } from "@/mocks/invoices";
import TaxInvoiceView from "../components/TaxInvoiceView";

export default function InvoiceDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const invoice = taxInvoices.find((item) => item.id === id) ?? null;

  if (!invoice) {
    return (
      <div className="yc-fade-up bg-white rounded-card border border-background-200 shadow-card px-8 py-20 text-center">
        <div className="mx-auto w-16 h-16 flex items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-4">
          <i className="ri-file-shield-2-line text-3xl"></i>
        </div>
        <h2 className="text-lg font-bold text-foreground-950">
          الفاتورة غير موجودة
        </h2>
        <p className="mt-1 text-sm text-foreground-500">
          تعذّر العثور على الفاتورة المطلوبة.
        </p>
        <button
          type="button"
          onClick={() => navigate("/invoices")}
          className="mt-5 inline-flex items-center gap-2 rounded-btn bg-primary-500 px-5 py-2.5 text-sm font-semibold text-white hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-right-line"></i>
          العودة للفواتير
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="yc-screen-only yc-fade-up flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => navigate("/invoices")}
            className="w-10 h-10 flex items-center justify-center rounded-full bg-white border border-background-200 text-foreground-700 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
            aria-label="رجوع"
          >
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
          <div>
            <h2 className="text-xl font-bold text-foreground-950">
              الفاتورة <span dir="ltr">{invoice.id}</span>
            </h2>
            <p className="mt-1 text-sm text-foreground-500">
              فاتورة ضريبية متوافقة مع ZATCA
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={() => window.print()}
          className="inline-flex items-center gap-2 rounded-btn bg-primary-500 px-5 py-2.5 text-sm font-semibold text-white hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-printer-line"></i>
          طباعة / حفظ PDF
        </button>
      </div>

      <div className="yc-screen-only yc-fade-up bg-white rounded-card border border-background-200 shadow-card overflow-hidden">
        <TaxInvoiceView invoice={invoice} />
      </div>

      <div className="yc-print-only">
        <TaxInvoiceView invoice={invoice} />
      </div>
    </div>
  );
}